import { ErrorBoundary } from "react-error-boundary";

import ContextSelector from "./context-selector";
import LoadingErrorCard from "./users/cards/loading-error-card";

function RootPage() {
  return (
    <main className="mx-auto grid max-w-xl gap-6 p-6">
      <ErrorBoundary fallback={<LoadingErrorCard />}>
        <ContextSelector />;
      </ErrorBoundary>
    </main>
  );
}

export default RootPage;
